import {Injectable, EventEmitter} from '@angular/core';
import {Constants} from "./constants";
import {HttpApiService} from "./http-api.service";
import {EndpointsService} from "./endpoints.service";
import {Subject} from "rxjs/Subject";

@Injectable()
export class TenantService {
  private tenant: any = null;
  private loggedInTenant: any = null;
  private tenantUpdateEvent = new Subject();

  constructor(private Api: HttpApiService,
              private endpoints: EndpointsService) {
  }

  getTenant() {
    const self = this;
    if (self.tenant) {
      this.tenantUpdateEvent.next(self.tenant);
      return;
    } else {
      this.Api.get(self.endpoints.getTenantUrl() + "/byDomain?domain=" + Constants.TENANT_ID())
        .subscribe(response => {
          self.tenant = response;
          self.tenantUpdateEvent.next(self.tenant);
        });
    }
  }

  getTenantWithPromise() {
    const self = this;
    return new Promise((resolve) => {
      if (self.tenant) {
        resolve(self.tenant);
      }
      self.Api.get(this.endpoints.getTenantUrl() + "/byDomain?domain=" + Constants.TENANT_ID())
        .subscribe(response => {
            self.tenant = response;
            resolve(self.tenant);
          },
          error => {
            console.log(error);
          });
    });
  }

  subscribeForTenant() {
    return this.tenantUpdateEvent;
  }

  getCurrentLoggedInTenant() {
    const self = this;
    return new Promise((resolve) => {
      if(self.loggedInTenant) {
        resolve(self.loggedInTenant);
      }
      self.Api.get(this.endpoints.getTenantByCurrentLoggedInUser(), true)
        .subscribe(response => {
            self.loggedInTenant = response;
            resolve(self.loggedInTenant);
          },
          error => {
            console.log(error);
          });
    });
  }

  clearTenant() {
    this.tenant = null;
  }

  getHeaderUrl() {
    return this.tenant.headerUrl;
  }

  getFooterUrl() {
    return this.tenant.footerUrl;
  }

  getCssUrl() {
    return this.tenant.cssUrl;
  }

  getLogoUrl() {
    return this.tenant.logoUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tenant.service.ts